import { Component } from '@angular/core';
import { PinShapeSvg } from './pin-shape-svg';

@Component({
  selector: 'topo-teardrop-svg',
  standalone: true,
  template: `
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m 26.851695,12.334419 c 0,9.6146 -12,17.0927 -12,17.0927 0,0 -12.0000001,-7.1122 -12.0000001,-17.0927 0,-6.4657604 5.37258,-11.70730036 12.0000001,-11.70730036 6.6274,0 12,5.24153996 12,11.70730036 z"
        [attr.fill]="color()" />
    </svg>
  `
})
export class TeardropSvgComponent extends PinShapeSvg {}
